import { render } from "./addBuyer.vue?vue&type=template&id=3b1966ea&scoped=true"
import script from "./addBuyer.vue?vue&type=script&lang=js"
export * from "./addBuyer.vue?vue&type=script&lang=js"

import "./addBuyer.vue?vue&type=style&index=0&id=3b1966ea&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1966ea"]])

export default __exports__